<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="disclaimer"><span><i>The characters and events portrayed herein are imaginary, and have no life outside these pages.</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4-disclaimer.vue?36049cc6